import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import knowledgeService, { notePath, openNotesPage } from '../../services/knowledgeService';
import usePermissions from '../../hooks/usePermissions';

// Re-checked every 15 minutes; the banner stays until a tenant administrator
// acknowledges the Note (FR-57). Never blocks or breaks the page under it.
const REFRESH_MS = 15 * 60 * 1000;

const HotNewsBanner = () => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const allowed = hasPermission('kb.acknowledge_hotnews');
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    if (!allowed) return;
    try {
      const { data } = await knowledgeService.getPendingHotNews();
      setItems(data.results || []);
    } catch {
      setItems([]);
    }
  }, [allowed]);

  useEffect(() => {
    load();
    if (!allowed) return undefined;
    const timer = setInterval(load, REFRESH_MS);
    return () => clearInterval(timer);
  }, [load, allowed]);

  if (!allowed || items.length === 0) return null;

  const first = items[0];
  return (
    <Alert
      severity="error"
      sx={{ mb: 2 }}
      action={(
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button color="inherit" size="small" onClick={() => openNotesPage(notePath(first.note_number))}>Read</Button>
          <Button color="inherit" size="small" variant="outlined" onClick={() => navigate('/knowledge/assistant')}>
            Acknowledge
          </Button>
        </Box>
      )}
    >
      <strong>HotNews:</strong> Biztimize Note {first.note_number} — {first.title}
      {items.length > 1 ? ` (and ${items.length - 1} more)` : ''}
    </Alert>
  );
};

export default HotNewsBanner;
